import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubDraftsRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-drafts',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
	exact: true,
};
